import { RouteCollection } from "@vm/vue-core";

import ComparisonPage from "./components/comparison-page.vue";

export default {
  basePath: "/",
  routes: [
    {
      path: "/",
      name: "comparison",
      component: ComparisonPage,
    },
  ],
} satisfies RouteCollection;
